import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { SharedService } from 'app/services/core/shared.service';
import { IFoaReportViewModel, IViewPTAnalyte, IViewPtModel, IViewPTResult } from 'app/models/report/reports';
import { ReportService } from 'app/services/report/report.service';
import { IPts, IPtViewResults } from 'app/models/pt/pt';
import { ILab } from 'app/models/lab-user-menu/lab';
import { ILabApplication } from 'app/models/application-menu/lab-application';

@Component({
  selector: 'ptSearchReport',
  templateUrl: './ptSearchReport.component.html',
  styleUrls: ['./ptSearchReport.component.scss']
})
export class PtSearchReportComponent {

  @ViewChild('pdf') pdf: PDFExportComponent;

  public ptReport: IViewPtModel = null;
  public fromDate: string = '';
  public toDate: string = '';
  public orelapId: string = '';
  public viewList: IPtViewResults[] = [];
  public PT_NOT_FOUND_ON_APP: string = "Analyte Not Found on APPID"
  public labApp: ILabApplication = null;
  

  public numberOfColumns: number = 0;

  constructor(public searchLabsService: SearchLabsService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<PtSearchReportComponent>,
    private reportService: ReportService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    // console.log('pt search report for application', this.sharedService.currentApplication);
    console.log('data passed to pt search report', data);
    this.labApp = this.sharedService.currentApplication;
    this.viewList = this.data.viewList;
    this.fromDate = this.data.from;
    this.toDate = this.data.to;
    this.orelapId = this.data.orelapId;
    this.numberOfColumns = this.data.numberOfColumns;
    
    // this.labName = this.data.labName;
    // this.list = this.data.list;
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Foa_Report.pdf');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
